import { useState } from "react";

import LayoutActividad from "../../../components/LayoutActividad";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import Card from "../../../components/Card";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo14/Unidad1Actividad3.mp3";

const Actividad5 = () => {
  const [showAnswers, setShowAnswers] = useState(false);

  const infoUnidad = modulo14.content[0];
  const infoAct = modulo14.content[0].activities[3];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo14.content[0].name}: ${modulo14.content[0].activities[4].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[0].path}/${modulo14.content[0].activities[4].path}`,
    titlePrev: `${modulo14.content[0].name}: ${modulo14.content[0].activities[2].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[0].path}/${modulo14.content[0].activities[2].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      {" "}
      <p>
        <small className={`c-${modulo14.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>
      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <div className="row">
        <div className="col-lg-10 col-12">
          <ul>
            <li>Lee el siguiente texto:</li>
          </ul>
          <Card>
            <p className="fs-5 p-2 p-md-0">
              Una <strong>lengua</strong> es un idioma. Es un sistema que nos
              permite comunicarnos a partir de palabras y frases. Hay miles de
              lenguas distintas en el mundo.
            </p>
            <p className="fs-5 p-2 p-md-0 pt-0">
              Un <strong>dialecto</strong> es una de las formas o variedades en
              que se habla una lengua. Por ejemplo, el castellano tiene muchas
              variedades. Es distinto el castellano que se habla en Argentina
              del que se habla en el Perú. Dentro del Perú también hay distintos
              castellanos o dialectos de castellano. Por ejemplo, el castellano
              que se habla en la selva es distinto al que se habla en la costa
            </p>
            <p className="fs-5 p-2 p-md-0 pt-0">
              Una <strong>familia de lenguas</strong> es un grupo de lenguas o
              idiomas que tienen el mismo origen. Por ejemplo, en el Perú existe
              la familia aru donde están el aimara (que se habla sobre todo en
              Puno), pero también el jaqaru y el kawki, que se hablan en la
              sierra de Lima y cada vez tienen menos hablantes.
            </p>
          </Card>
          <ul className="mt-5">
            <li>
              Ahora completa los recuadros del gráfico que aparece a
              continuación con los siguientes conceptos: familia de lenguas,
              dialecto y lengua. Algunos conceptos se repetirán en varios
              recuadros.
            </li>
          </ul>

          <div className="row mt-5 mb-4">
            <div className="col-6 offset-3">
              <input
                type="text"
                id="camp1"
                className="form-control a"
                aria-describedby="passwordHelpInline"
              />
              <div className="act3-line-1"></div>
              <div className="act3-line-2"></div>
            </div>
          </div>
          <div className="row my-5">
            <div className="col-4 offset-2">
              <input
                type="text"
                id="camp2"
                className="form-control B"
                aria-describedby="passwordHelpInline"
              />
            </div>
            <div className="col-4 offset-1">
              <input
                type="text"
                id="camp3"
                className="form-control"
                aria-describedby="passwordHelpInline"
              />
            </div>
          </div>
          <div className="act3-line-3"></div>
          <div className="act3-line-4"></div>
          <div className="act3-line-5"></div>
          <div className="act3-line-6"></div>
          <div className="act3-line-7"></div>
          <div className="row">
            <div className="col-2 offset-2">
              <input
                type="text"
                id="camp2"
                className="form-control"
                aria-describedby="passwordHelpInline"
              />
            </div>
            <div className="col-2">
              <input
                type="text"
                id="camp3"
                className={
                  showAnswers ? "form-control input-valid" : "form-control"
                }
                aria-describedby="passwordHelpInline"
              />
            </div>
            <div className="col-2">
              <input
                type="text"
                id="camp3"
                className={
                  showAnswers ? "form-control input-wrong" : "form-control"
                }
                aria-describedby="passwordHelpInline"
              />
            </div>
            <div className="col-2">
              <input
                type="text"
                id="camp3"
                className="form-control"
                aria-describedby="passwordHelpInline"
              />
            </div>
            <div className="col-2">
              <input
                type="text"
                id="camp3"
                className="form-control"
                aria-describedby="passwordHelpInline"
              />
            </div>
          </div>
          <div className="d-flex w-100 justify-content-end mt-5">
            <button
              className={`btn btn-${modulo14.color} `}
              onClick={() => setShowAnswers(true)}
            >
              Enviar respuestas
            </button>
          </div>
        </div>
      </div>
      <GuiaDocente>
        <ul>
          <li>
            Explique que en las siguientes actividades
            trabajarán con ciertos conceptos que resultan fundamentales para
            comprender la diversidad lingüística en nuestro país. Así, se
            aproximarán a la distinción entre lenguas, dialectos y familias de
            lenguas, así como al significado de palabras clave como bilingüe y
            multilingüe.
          </li>
          <li>
            Lea la primera indicación: Lee el siguiente texto. Pida que lean el texto. Deténgase después de cada párrafo y
            asegúrese de que han comprendido la definición que se plantea.
            Pregunte cuál es la diferencia entre lengua,
            dialecto y familia de lenguas. Aclare que en una familia de lenguas
            se pueden encontrar dos o más lenguas que tienen el mismo origen;
            por eso, a pesar de ser distintas, se les considera parte de una
            misma familia. Además, cada lengua tiene distintas variedades
            (distintas formas de hablar un mismo idioma) a las que se les
            denomina dialectos. Explique que para comprender mejor la distinción
            y la relación entre familia de lenguas, lengua y dialecto, deben
            completar el ordenador gráfico.
          </li>
          <li>
            Lea la segunda indicación: Ahora completa los recuadros del gráfico
            que aparece a continuación con los siguientes conceptos: familia de
            lenguas, dialecto y lengua. Algunos conceptos se repetirán en varios
            recuadros. Dé un tiempo para que llenen el gráfico.
            Luego corríjalo en voz alta. Para ello, retome la explicación de los
            conceptos.
          </li>
          <li>
            Familia de lenguas {">"} Lengua {">"} Dialecto
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad5;
